// ============================================================================
// CONTACT MOBILE COMPONENT
// ============================================================================
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import schoolLogo from '../school-brand.jpg';

function ContactMobile() {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    enquiryType: 'general',
    name: '',
    email: '',
    message: ''
  });

  const [isSending, setIsSending] = useState(false);
  const [quickEmail, setQuickEmail] = useState('');
  const [quickPassword, setQuickPassword] = useState('');
  const [showQuickLogin, setShowQuickLogin] = useState(false);

  // Forgot Password States
  const [isForgotMode, setIsForgotMode] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotMessage, setForgotMessage] = useState('');

  const handleQuickLogin = async (e) => {
    e.preventDefault();
    try {
      localStorage.removeItem('instructorId');
      localStorage.removeItem('learnerId');
      localStorage.removeItem('userId');
      localStorage.removeItem('adminToken');

      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: quickEmail, password: quickPassword })
      });
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem('needsPasswordReset', data.needsPasswordReset ? 'true' : 'false');

        if (data.role === 'admin') {
          localStorage.setItem('userRole', 'admin');
          localStorage.setItem('adminToken', data.token || 'mock-admin-token-secure');
          window.location.assign('/admin');
        } else if (data.role === 'instructor') {
          localStorage.setItem('userRole', 'instructor');
          localStorage.setItem('instructorId', data.id || data.instructorId);
          localStorage.setItem('token', data.token || '');
          window.location.assign('/instructor-dash');
        } else {
          localStorage.setItem('userRole', 'learner');
          localStorage.setItem('userId', data.id || data.userId);
          localStorage.setItem('learnerId', data.id || data.userId);
          localStorage.setItem('userName', data.name || "Learner Driver");
          localStorage.setItem('token', data.token || '');
          window.location.assign(`/learner-dash/${data.instructor_id || 5}`);
        }
      } else {
        alert(data.error || "Login failed.");
      }
    } catch (err) {
      alert("Server error.");
    }
  };

  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: forgotEmail })
      });
      const data = await res.json();
      if (res.ok) {
        setForgotMessage('Password reset link sent! Check your email.');
      } else {
        setForgotMessage(data.error || 'Could not send reset link.');
      }
    } catch (err) {
      setForgotMessage('Server error. Please try again.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSending) return;
    setIsSending(true);

    try {
      const subjectMapping = {
        general: 'General Enquiry',
        instructor_account: 'Instructor Account Support',
        find_instructor: 'Find an Instructor / Coverage'
      };

      const payload = {
        ...formData,
        subject: subjectMapping[formData.enquiryType] || 'General Enquiry'
      };

      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        setSubmitted(true);
        setFormData({
          enquiryType: 'general',
          name: '',
          email: '',
          message: ''
        });
      } else {
        alert('Failed to send message. Please try again.');
      }
    } catch (err) {
      console.error('Contact error:', err);
      alert('Server error. Could not send message.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div style={{ padding: '0 0 50px 0', maxWidth: '100%', margin: '0 auto', color: '#ffffff', fontFamily: 'inherit', background: '#0f172a', minHeight: '100vh', boxSizing: 'border-box' }}>
      
   {/* --- MINIMALIST APP HEADER --- */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 18px', background: '#090d16', borderBottom: '1px solid rgba(255,255,255,0.06)', position: 'sticky', top: 0, zIndex: 1000 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src={schoolLogo} alt="Logo" style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #3b82f6' }} />
          <Link to="/" style={{ color: '#fff', fontWeight: '800', fontSize: '1.1rem', letterSpacing: '-0.5px', textDecoration: 'none' }}>LessonLane</Link>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Link to="/" title="Home" style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff', padding: '6px 10px', borderRadius: '8px', textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" fill="#FFFFFF"/>
            </svg>
          </Link>
          <button 
            onClick={() => { setShowQuickLogin(!showQuickLogin); setIsForgotMode(false); setForgotMessage(''); }}
            title="Portal Login"
            style={{ background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4px' }}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C9.24 2 7 4.24 7 7C7 9.42 8.74 11.43 11 11.9V13.1C7.58 13.54 5 16.48 5 20H19C19 16.48 16.42 13.54 13 13.1V11.9C15.26 11.43 17 9.42 17 7C17 4.24 14.76 2 12 2Z" fill="#FFFFFF"/>
            </svg>
          </button>
        </div>
      </div>

      {/* --- QUICK LOGIN / FORGOT PASSWORD EXPANDABLE BOX --- */}
      {showQuickLogin && (
        <div style={{ padding: '16px 16px 0 16px', maxWidth: '450px', margin: '0 auto', width: '100%', boxSizing: 'border-box' }}>
          {!isForgotMode ? (
            <form onSubmit={handleQuickLogin} style={{ background: '#1e293b', padding: '20px', borderRadius: '16px', border: '2px solid #3b82f6', boxShadow: '0 12px 30px rgba(0, 0, 0, 0.4)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <h4 style={{ margin: 0, fontSize: '1rem', color: '#ffffff', fontWeight: '800' }}>Portal Sign In</h4>
                <button type="button" onClick={() => setShowQuickLogin(false)} style={{ background: 'none', border: 'none', fontSize: '14px', cursor: 'pointer', color: '#94a3b8' }}>✕</button>
              </div>
              <input 
                type="email" 
                placeholder="Email address" 
                value={quickEmail} 
                onChange={e => setQuickEmail(e.target.value)} 
                required 
                style={{ width: '100%', padding: '11px 12px', marginBottom: '10px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', boxSizing: 'border-box', fontSize: '13px', background: '#0f172a', color: '#fff', outline: 'none' }}
              />
              <input 
                type="password" 
                placeholder="Password" 
                value={quickPassword} 
                onChange={e => setQuickPassword(e.target.value)} 
                required 
                style={{ width: '100%', padding: '11px 12px', marginBottom: '6px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', boxSizing: 'border-box', fontSize: '13px', background: '#0f172a', color: '#fff', outline: 'none' }}
              />
              <div style={{ textAlign: 'right', marginBottom: '12px' }}>
                <button 
                  type="button"
                  onClick={() => { setIsForgotMode(true); setForgotMessage(''); }}
                  style={{ background: 'none', border: 'none', fontSize: '11.5px', color: '#60a5fa', textDecoration: 'none', cursor: 'pointer', padding: 0 }}
                >
                  Forgot password?
                </button>
              </div>
              <button type="submit" style={{ width: '100%', padding: '11px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer' }}>
                Sign In
              </button>
            </form>
          ) : (
            <form onSubmit={handleForgotPasswordSubmit} style={{ background: '#1e293b', padding: '20px', borderRadius: '16px', border: '2px solid #3b82f6', boxShadow: '0 12px 30px rgba(0, 0, 0, 0.4)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <h4 style={{ margin: 0, fontSize: '1rem', color: '#ffffff', fontWeight: '800' }}>Reset Password</h4>
                <button type="button" onClick={() => setShowQuickLogin(false)} style={{ background: 'none', border: 'none', fontSize: '14px', cursor: 'pointer', color: '#94a3b8' }}>✕</button>
              </div>
              <p style={{ fontSize: '11.5px', color: '#94a3b8', marginBottom: '12px', lineHeight: '1.4' }}>
                Enter your account email and we'll send you a recovery link.
              </p>
              <input 
                type="email" 
                placeholder="Enter your email address" 
                value={forgotEmail} 
                onChange={e => setForgotEmail(e.target.value)} 
                required 
                style={{ width: '100%', padding: '11px 12px', marginBottom: '10px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', boxSizing: 'border-box', fontSize: '13px', background: '#0f172a', color: '#fff', outline: 'none' }}
              />
              {forgotMessage && (
                <div style={{ fontSize: '11.5px', color: forgotMessage.includes('sent') ? '#10b981' : '#f87171', marginBottom: '10px' }}>
                  {forgotMessage}
                </div>
              )}
              <button type="submit" style={{ width: '100%', padding: '11px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer', marginBottom: '8px' }}>
                Send Reset Link ➔
              </button>
              <div style={{ textAlign: 'center' }}>
                <button 
                  type="button" 
                  onClick={() => setIsForgotMode(false)}
                  style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: '11px', cursor: 'pointer', textDecoration: 'underline' }}
                >
                  Back to Sign In
                </button>
              </div>
            </form>
          )}
        </div>
      )}

      <div style={{ padding: '20px 16px', maxWidth: '600px', margin: '0 auto', boxSizing: 'border-box' }}>
        
        {/* CLEAN STREAMLINED HERO HEADER */}
        <div style={{ textAlign: 'center', marginBottom: '16px', padding: '12px 0' }}>
          <h1 style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: '900', margin: '0', letterSpacing: '-0.5px', color: '#ffffff' }}>
            Contact LessonLane
          </h1>
        </div>

        {/* FORM CARD WITH AMBER BORDER */}
        <div
          style={{
            background: '#162238',
            padding: '26px 20px',
            borderRadius: '20px',
            border: '1.5px solid rgba(217, 119, 6, 0.5)',
            boxShadow: '0 12px 35px rgba(217, 119, 6, 0.15)'
          }}
        >
          {submitted ? (
            <div style={{ textAlign: 'center', padding: '25px 10px' }}>
              <div
                style={{
                  width: '60px',
                  height: '60px',
                  margin: '0 auto 16px',
                  borderRadius: '50%',
                  background: 'rgba(16, 185, 129, 0.15)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#34d399',
                  fontSize: '26px',
                  fontWeight: '800',
                  border: '1px solid rgba(52, 211, 153, 0.3)'
                }}
              >
                ✓
              </div>

              <h2 style={{ color: '#ffffff', fontSize: '1.3rem', fontWeight: '800', margin: '0 0 8px' }}>
                Message Sent
              </h2>

              <p style={{ color: '#94a3b8', fontSize: '0.88rem', lineHeight: '1.5', maxWidth: '380px', margin: '0 auto 20px' }}>
                Thank you for getting in touch. Your message has been successfully sent and we'll get back to you shortly.
              </p>

              <button type="button" onClick={() => setSubmitted(false)} style={secondaryButtonStyle}>
                Send Another Message
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              
              {/* ENQUIRY TYPE DROPDOWN */}
              <div>
                <label style={labelStyle}>Enquiry Type</label>
                <select
                  value={formData.enquiryType}
                  onChange={e => setFormData({ ...formData, enquiryType: e.target.value })}
                  style={inputStyle}
                  onFocus={e => e.target.style.borderColor = '#d97706'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'}
                >
                  <option value="general" style={{ background: '#0f172a', color: '#fff' }}>General Enquiry</option>
                  <option value="instructor_account" style={{ background: '#0f172a', color: '#fff' }}>Instructor Account Support</option>
                  <option value="find_instructor" style={{ background: '#0f172a', color: '#fff' }}>Find an Instructor / Coverage</option>
                </select>
              </div>

              {/* NAME */}
              <div>
                <label style={labelStyle}>Your Name</label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={e => setFormData({ ...formData, name: e.target.value })}
                  style={inputStyle}
                  onFocus={e => e.target.style.borderColor = '#d97706'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'}
                  placeholder="Your name"
                />
              </div>

              {/* EMAIL */}
              <div>
                <label style={labelStyle}>Email Address</label>
                <input
                  type="email"
                  required
                  value={formData.email}
                  onChange={e => setFormData({ ...formData, email: e.target.value })}
                  style={inputStyle}
                  onFocus={e => e.target.style.borderColor = '#d97706'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'}
                  placeholder="you@example.com"
                />
              </div>

              {/* MESSAGE */}
              <div>
                <label style={labelStyle}>Message</label>
                <textarea
                  required
                  rows="4"
                  value={formData.message}
                  onChange={e => setFormData({ ...formData, message: e.target.value })}
                  style={{ ...inputStyle, resize: 'vertical', minHeight: '110px', lineHeight: '1.5' }}
                  onFocus={e => e.target.style.borderColor = '#d97706'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'}
                  placeholder="How can we help?"
                />
              </div>

              {/* SUBMIT BUTTON */}
              <button
                type="submit"
                disabled={isSending}
                style={{
                  ...primaryButtonStyle,
                  opacity: isSending ? 0.7 : 1,
                  cursor: isSending ? 'not-allowed' : 'pointer'
                }}
              >
                {isSending ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          )}
        </div>

        {/* HELP SECTION */}
        {!submitted && (
          <div
            style={{
              marginTop: '16px',
              background: '#162238',
              border: '1px solid rgba(217, 119, 6, 0.3)',
              borderRadius: '16px',
              padding: '16px',
              textAlign: 'center'
            }}
          >
            <h3 style={{ color: '#fbbf24', fontSize: '0.95rem', fontWeight: '800', margin: '0 0 4px' }}>
              Looking for answers?
            </h3>
            <p style={{ color: '#94a3b8', fontSize: '0.82rem', lineHeight: '1.4', margin: 0 }}>
              Check out our <Link to="/faq" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })} style={{ color: '#fbbf24', textDecoration: 'underline' }}>FAQ page</Link> for common questions.
            </p>
          </div>
        )}
      </div>

      {/* --- MOBILE FOOTER --- */}
      <div style={{ textAlign: 'center', padding: '20px 16px', background: '#090d16', color: '#94a3b8', marginTop: '30px', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
        <p style={{ fontSize: '11px', margin: 0 }}>
          &copy; 2026 LessonLane.co.uk. All rights reserved.
        </p>
      </div>

    </div>
  );
}

/* ============================================================
   STYLES
   ============================================================ */

const labelStyle = {
  fontSize: '0.72rem',
  color: '#94a3b8',
  fontWeight: '800',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  marginBottom: '5px',
  display: 'block'
};

const inputStyle = {
  width: '100%',
  padding: '11px 13px',
  background: '#0f172a',
  border: '1px solid rgba(255,255,255,0.15)',
  color: '#ffffff',
  borderRadius: '10px',
  fontSize: '14px',
  fontWeight: '500',
  boxSizing: 'border-box',
  outline: 'none',
  fontFamily: 'inherit',
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
};

const primaryButtonStyle = {
  width: '100%',
  padding: '13px 20px',
  background: 'linear-gradient(135deg, #d97706 0%, #b45309 100%)',
  color: '#ffffff',
  border: 'none',
  borderRadius: '10px',
  fontWeight: '700',
  cursor: 'pointer',
  fontSize: '14px',
  boxShadow: '0 6px 20px rgba(217, 119, 6, 0.4)',
  transition: 'all 0.2s ease'
};

const secondaryButtonStyle = {
  padding: '10px 18px',
  backgroundColor: 'rgba(255,255,255,0.08)',
  color: '#ffffff',
  border: '1px solid rgba(255,255,255,0.15)',
  borderRadius: '10px',
  fontWeight: '700',
  cursor: 'pointer',
  fontSize: '13px'
};

export default ContactMobile;